import React, {useState, useEffect} from 'react'
import {Button, styled, Dialog, DialogTitle, DialogContent, DialogActions, Typography} from '@mui/material'
import './index.scss'

interface AccessPopupProps {
    isOpen: boolean
    pageName?: string
}

const AccessPopup = ({
    isOpen,
    pageName
}: AccessPopupProps) => {
    const [isPopupOpen, setPopupOpen] = useState<boolean>(isOpen)

    useEffect(() => {
        setPopupOpen(isOpen)
    }, [isOpen])

    const BootstrapDialog = styled(Dialog)(({theme}) => ({
        zIndex: theme.zIndex.modal + 1,
        '& .MuiDialogContent-root': {
            padding: theme.spacing(2)
        },
        '& .MuiDialogActions-root': {
            padding: theme.spacing(1)
        }
    }))

    const handleClose = (_event: Record<string, any>, reason?: string) => {
        if (reason && (reason === 'backdropClick' || reason === 'escapeKeyDown')) return
        setPopupOpen(false)
    }

    return (
        <div>
            <BootstrapDialog className='AccessPopupDlg' open={isPopupOpen} onClose={handleClose}>
                <DialogTitle sx={{m: 0, p: 2}} id='title'>
                    We’re sorry.
                </DialogTitle>

                <DialogContent dividers>
                    <Typography gutterBottom className='text'>
                        You do not have access to the {pageName} feature in CPS. Please reach out to your administrator
                        for assistance or to request access.{' '}
                    </Typography>
                </DialogContent>
                <DialogActions sx={{m: 1, p: 2}}>
                    <Button className='OkBtn' onClick={(e) => handleClose(e)}>
                        Okay
                    </Button>
                </DialogActions>
            </BootstrapDialog>
        </div>
    )
}
export default AccessPopup
